export default "__VITE_ASSET__BTuj37ML__$_?height=200&width=300__"